module.exports = __webpack_public_path__ + "img/back-white.081f390d.svg";